import { RepostIcon } from '@synoptic/ui-kit/icons/react/repost.tsx';
import { postCardReposted, postCardRepostedText } from './post-card.css.ts';

export const PostCardRepostAuthor = ({
  fullName,
}: {
  fullName: string;
}) => {
  return (
    <div className={postCardReposted}>
      <RepostIcon />
      <span className={postCardRepostedText}>
        {fullName} reposted this
      </span>
    </div>
  );
};
